<template>
  <div id="app">
    <Main msg="Pick a Stick Decision Maker"/>
  </div>
</template>

<script>
import Main from './components/Main.vue'

export default {
  name: 'App',
  components: {
    Main
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Gaegu&display=swap');
html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}

#app {
  font-family: 'Gaegu', cursive, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
